import request from './index'

export const remoteControl=(carId,quadrantSend)=>{
    return request({
        url:'/remote/remoteControl',
        method:'post',
        data:{
            command_id : "71",
            carId : carId,
            ccuQuadrant : quadrantSend
        }
    })
}